// HEADER
export const menu = ["home", "about", "services", "careers"];

// HERO
import pic1 from "../images/hero/highway_and_road_engineering.webp";
import pic2 from "../images/hero/transportation_planning.webp";
import pic3 from "../images/hero/design_build_services.webp";
import pic4 from "../images/hero/water.webp";
import pic5 from "../images/hero/bridges.webp";
import pic6 from "../images/hero/construction_services.webp";
import arrow from "../images/hero/ArrowUp.svg";

import aboutpic1 from "../images/about/pic1.webp";
import aboutpic2 from "../images/about/pic2.webp";

export const heroServices = [
  {
    id: "highway",
    title: "Highway & Road",
    url: "https://",
    pics: pic1,
    arrow,
    description: [
      "Our mission is to accomplish great things, exceed our clients’ expectations and meet the challenges of our growing infrastructure through practical engineering solutions, innovation, and hard work.",
      "Our diverse group of Professional Engineers and Designers lead the way by providing a full range of  services in roads and highways: hands-on design management of roadway design, traffic control plans, schematic design, minor and major bridge design, traffic engineering studies, traffic demand modeling, intelligent transportation systems, signing and pavement markings, roadway hydraulics, from minor crossings through major highways and interchanges across the state, including the reconstruction of the $1.5 billion US 290 corridor.",
    ],
  },
  {
    id: "transportation",
    title: "Transportation Planning",
    url: "https://",
    pics: pic2,
    arrow,
    description: [
      "OTHON’s reputable construction management services have provided critical support in the delivery of many high-profile projects, including the $2.5 billion Katy Freeway Reconstruction Project, Bush Intercontinental Airport Rehabilitation, Houston Toyota Center, 2013 Fort Bend Mobility Bond Program and the $1.5 billion US 290 Reconstruction Project.",
      "We assist our clients by providing a comprehensive array of services aimed to facilitate construction from opening to final completion including Construction Management and Inspection Services, Scheduling and Mitigation Strategies, and Public Involvement and Community Outreach services.",
      "OTHON provides comprehensive constructability review for all design components and recommendation of the contractor’s schedule, troubleshooting field problems, review of contractor’s change orders, coordination with agencies and adjacent projects, and time impact analysis. Through effective management and coordination from project kick-off to close-out, our Construction Services team is committed to delivering projects on time and under budget.",
    ],
  },
  {
    id: "design",
    title: "Design Build Services",
    url: "https://",
    pics: pic3,
    arrow,
    description: [
      "Our mission is to accomplish great things, exceed our clients’ expectations and meet the challenges of our growing infrastructure through practical engineering solutions, innovation, and hard work.",
      "Our diverse group of Professional Engineers and Designers lead the way by providing a full range of  services in roads and highways: hands-on design management of roadway design, traffic control plans, schematic design, minor and major bridge design, traffic engineering studies, traffic demand modeling, intelligent transportation systems, signing and pavement markings, roadway hydraulics, from minor crossings through major highways and interchanges across the state, including the reconstruction of the $1.5 billion US 290 corridor.",
    ],
  },
  {
    id: "water",
    title: "Water",
    url: "https://",
    pics: pic4,
    arrow,
    description: [
      "OTHON’s reputable construction management services have provided critical support in the delivery of many high-profile projects, including the $2.5 billion Katy Freeway Reconstruction Project, Bush Intercontinental Airport Rehabilitation, Houston Toyota Center, 2013 Fort Bend Mobility Bond Program and the $1.5 billion US 290 Reconstruction Project.",
      "We assist our clients by providing a comprehensive array of services aimed to facilitate construction from opening to final completion including Construction Management and Inspection Services, Scheduling and Mitigation Strategies, and Public Involvement and Community Outreach services.",
      "OTHON provides comprehensive constructability review for all design components and recommendation of the contractor’s schedule, troubleshooting field problems, review of contractor’s change orders, coordination with agencies and adjacent projects, and time impact analysis. Through effective management and coordination from project kick-off to close-out, our Construction Services team is committed to delivering projects on time and under budget.",
    ],
  },
  {
    id: "bridges",
    title: "Bridges",
    url: "https://",
    pics: pic5,
    arrow,
    description: [
      "Our mission is to accomplish great things, exceed our clients’ expectations and meet the challenges of our growing infrastructure through practical engineering solutions, innovation, and hard work.",
      "Our diverse group of Professional Engineers and Designers lead the way by providing a full range of  services in roads and highways: hands-on design management of roadway design, traffic control plans, schematic design, minor and major bridge design, traffic engineering studies, traffic demand modeling, intelligent transportation systems, signing and pavement markings, roadway hydraulics, from minor crossings through major highways and interchanges across the state, including the reconstruction of the $1.5 billion US 290 corridor.",
    ],
  },
  {
    id: "construction",
    title: "Construction Services",
    url: "https://",
    pics: pic6,
    arrow,
    description: [
      "OTHON’s reputable construction management services have provided critical support in the delivery of many high-profile projects, including the $2.5 billion Katy Freeway Reconstruction Project, Bush Intercontinental Airport Rehabilitation, Houston Toyota Center, 2013 Fort Bend Mobility Bond Program and the $1.5 billion US 290 Reconstruction Project.",
      "We assist our clients by providing a comprehensive array of services aimed to facilitate construction from opening to final completion including Construction Management and Inspection Services, Scheduling and Mitigation Strategies, and Public Involvement and Community Outreach services.",
      "OTHON provides comprehensive constructability review for all design components and recommendation of the contractor’s schedule, troubleshooting field problems, review of contractor’s change orders, coordination with agencies and adjacent projects, and time impact analysis. Through effective management and coordination from project kick-off to close-out, our Construction Services team is committed to delivering projects on time and under budget.",
    ],
  },
];

// ABOUT

export const about = [
  {
    title: "Mission:",
    description:
      "Deliver service and execution excellence when providing high-quality engineering solutions. Apply innovative, reliable and cost-effective solutions.",
  },
  {
    title: "Vision:",
    description:
      "Improve the quality of life in our communities, one project at a time. Develop strategic relationships with valued clients. Be a responsive and trusted partner of choice to our valued clients.",
  },
  {
    title: "What We Do:",
    description:
      "OTHON is a national DBE/MBE engineering firm providing professional civil engineering, construction management, and environmental services to governmental entities, private industry, and other engineering firms - regionally, nationally, and internationally.",
  },
];

export const aboutHistory = [
  {
    title:
      "In 1998, OTHON expanded its operations with the addition of an      office in the Dallas, Texas region, and in 2023 opened a third office in Austin, Texas.",
    pic: aboutpic1,
    alt: "about team 1",
  },
  {
    title:
      "Throughout the company’s progress, we have remained committed to our core values and vision. Making a difference in the lives of the people and communities we serve is paramount to our work. It is the why we work hard and smart to deliver the highest quality of services in the civil engineering industry.",
    pic: aboutpic2,
    alt: "about team2",
  },
];
